import { useGetApiV1ClientCurrenciesQuery } from 'service/api/allApis';
import CustomSelectOutline from '../custom-select/outline';
import { useSelector } from 'react-redux';
import { selectSettings, setCurrency } from 'store/features/settingsSlice';
import { useAppDispatch } from 'store';

const ChangeCurrency = () => {
    const { currency } = useSelector(selectSettings);
    const dispatch = useAppDispatch();
    const { data } = useGetApiV1ClientCurrenciesQuery({
        isPaginated: false,
    });
    const currencies = data?.items || [];
    const options = currencies.map((language) => ({
        value: String(language.exchangeRate!),
        label: language.code!,
    }));

    if (!options.length) {
        return null;
    }

    return (
        <CustomSelectOutline
            value={currency.exchangeRate}
            onChange={(option) =>
                dispatch(
                    setCurrency({
                        exchangeRate: option.value,
                        code: option.label,
                    }),
                )
            }
            options={options}
            dropDownClassName="bg-brend border-white"
        />
    );
};

export default ChangeCurrency;
